import { removeData } from 'jquery';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import i18n from "i18next";
import { API_URL } from '../../../config';
import { useTranslation, initReactI18next } from "react-i18next";
import user from '../../images/user.png'

const Login = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [alerts, setalerts] = useState(false)
    const [Loader, setLoader] = useState(false)
    const navigate = useNavigate();
    const [passwordShown, setPasswordShown] = useState(false);

    
    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    async function loginUser(event) {
        event.preventDefault()
        setalerts(false)
        setLoader(true)

        const response = await fetch(API_URL+'/admin/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                password,
            }),
        })



        const data = await response.json()
        setLoader(false)

        if (data.status) {
            // console.log(data);
            
            localStorage.setItem('user_id', data.user_id);
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('user_type', data.data[0].user_type);
            localStorage.setItem('uid', data.data[0].uid);
            localStorage.setItem('user_name', data.data[0].firstname + " "+ data.data[0].lastname);
            
      
            navigate("/affiliate");


        } else {
            setalerts(true)


        }

        // alert('Logined')
    }

    return (
        <div className='login-bg'>
            <div className="wrp-login">
                <form onSubmit={loginUser}>
                    <div className="login-content">
                        <div className="login-database">
                            <p>Login to Better Physiology Dashboard</p>
                        </div>
                        <div className="user-img">
                            <img src={user} alt="user-img" />
                        </div>

                        <div className="wrp-label">
                            <label>Email Address</label>
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                placeholder="Email"
                            />
                        </div>
                        <div className="wrp-label passwordInput mrt-input">
                            <label>Password</label>
                            <input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type={passwordShown ? "text" : "password"}
                                placeholder="Password"
                            />

                        {
                                passwordShown ? <i class="fa fa-eye-slash pass-eye" aria-hidden="true" onClick={togglePasswordVisiblity}></i> : <i className="fa fa-eye pass-eye" aria-hidden="true" onClick={togglePasswordVisiblity}></i>
                            }
                        </div>
                        {
                            alerts &&
                            <p className="invalid-p">Invalid Login</p>
                        }

                        <button className="login-btn" type="submit" >Login
                            {
                                Loader && 
                                <div id="loader"></div>
                            }
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
}


export default Login;